import {
  IconBell,
  IconBinocularsGray,
  IconChainLink,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconTagGray,
  IconTvocGray,
  IconUserCheck,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import mainVideo from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/logisticsManage/img/1.avif';
import image2 from '@src/assets/images/solution/logisticsManage/img/2.avif';
import image3 from '@src/assets/images/solution/logisticsManage/img/3.avif';
import image4 from '@src/assets/images/solution/logisticsManage/img/4.avif';
import image5 from '@src/assets/images/solution/logisticsManage/img/5.avif';
import image6 from '@src/assets/images/solution/logisticsManage/img/6.avif';

export default {
  type: 'Giải pháp xây dựng',

  banner: {
    title: 'Tự động theo dõi vị trí xe container trong kho nội bộ phức tạp',
    desc: 'Dễ dàng nắm bắt vị trí xe container trong kho rộng lớn theo thời gian thực và kiểm tra ngay các khu vực đỗ xe còn trống.',
  },

  video: {
    title: 'Dù kho phức tạp, xe luôn di chuyển đúng mục tiêu',
    desc: 'Thẻ RTLS gắn trên xe container kết hợp với hạ tầng định vị trong nhà giúp tự động nhận dạng vị trí. Bảng điều khiển hiển thị vị trí đỗ xe và luồng di chuyển của xe theo thời gian thực, giúp công nhân bắt đầu công việc ngay mà không bị nhầm lẫn.',
    play: mainVideo,
  },

  func: [
    {
      theme: 'Theo dõi xe & thu thập dữ liệu vị trí',
      title: 'Tự động nhận dạng vị trí xe container',
      desc: 'Mỗi xe được gắn thẻ RTLS để tự động nhận dạng vị trí theo thời gian thực. Tọa độ được hiển thị trực quan trên bảng điều khiển, giúp nắm rõ vị trí và trạng thái hiện tại.',
      sub1: 'Độ chính xác cao',
      icon1: IconRulerGray,
      sub2: 'Theo dõi trạng thái theo thời gian thực',
      icon2: IconClockGray,
      image: image1,
    },
    {
      title: 'Hiển thị khu vực đỗ xe trống theo thời gian thực',
      desc: 'Hệ thống tự động phân tích và hiển thị trực quan các vị trí đỗ xe còn trống cho tài xế. Xe có thể di chuyển thẳng đến vị trí tối ưu, giảm thời gian chờ đợi.',
      sub1: 'Theo dõi vị trí theo thời gian thực',
      icon1: IconBinocularsGray,
      sub2: 'Kết nối dữ liệu nhanh',
      icon2: IconTvocGray,
      image: image2,
    },
    {
      title: 'Hình ảnh hóa lộ trình tránh trùng tuyến',
      desc: 'Khi nhiều xe di chuyển cùng lúc, lộ trình dự kiến sẽ được hiển thị để tránh va chạm. Giúp ngăn chặn tắc nghẽn trước, sắp xếp lối vào và lối ra một cách gọn gàng.',
      sub1: 'Theo dõi vị trí theo thời gian thực',
      icon1: IconBinocularsGray,
      sub2: 'Độ chính xác cao',
      icon2: IconRulerGray,
      image: image3,
    },
    {
      theme: 'Tự động hóa quản lý & chứng minh vận hành',
      title: 'Chức năng tìm kiếm vị trí container',
      desc: 'Nhân viên có thể nhập số container hoặc số xe vào ô tìm kiếm để kiểm tra ngay vị trí hiện tại. Không cần tìm thủ công, dễ dàng tiếp cận xe mục tiêu, tăng tốc độ công việc.',
      sub1: 'Cài đặt khu vực linh hoạt',
      icon1: IconZoneGray,
      sub2: 'Cài đặt nhiều khu vực',
      icon2: IconTagGray,
      image: image4,
    },
    {
      title: 'Quản lý lịch sử ra vào & di chuyển',
      desc: 'Hành trình di chuyển từ lúc xe vào đến vị trí cuối cùng được lưu dưới dạng dòng thời gian. Thông tin này có thể sử dụng để phân tích luồng logistics hoặc làm minh chứng xuất nhập sau này.',
      sub1: 'Cài đặt khu vực linh hoạt',
      icon1: IconZoneGray,
      sub2: 'Cài đặt nhiều khu vực',
      icon2: IconTagGray,
      image: image5,
    },
    {
      title: 'Cảnh báo theo thời gian thực & bảng điều khiển quản lý',
      desc: 'Khi phát hiện tuyến đường bất thường, chờ lâu, đỗ sai khu vực, cảnh báo sẽ gửi đến quản lý ngay lập tức. Bảng điều khiển giám sát toàn diện tình hình hiện tại.',
      sub1: 'Cài đặt khu vực linh hoạt',
      icon1: IconZoneGray,
      sub2: 'Cài đặt nhiều khu vực',
      icon2: IconTagGray,
      image: image6,
    },
  ],

  subfunc: {
    title: 'Nhiều chức năng',
    desc: 'Đảm bảo an toàn cho người lao động giúp nâng cao hiệu suất và giảm thiểu thiệt hại do tai nạn. ORBRO cung cấp các chức năng tối ưu để bảo vệ công nhân tại công trường xây dựng. Hệ thống sẽ phản ứng phù hợp khi công nhân tiếp cận khu vực nguy hiểm, tai nạn xảy ra hoặc có rủi ro từ thiết bị hạng nặng.',

    data: [
      { icon: IconBinocularsGray, title: 'Theo dõi container', desc: 'Tag theo dõi & hiển thị vị trí.' },
      { icon: IconClockGray, title: 'Trạng thái bãi ngoài trời', desc: 'AI nhận xe, hiển thị ngay.' },
      { icon: IconChartBarGray, title: 'Phân tích bãi đậu', desc: 'Xác định chỗ trống kịp thời.' },
      { icon: IconSearch, title: 'Tìm theo số', desc: 'Nhập số để tìm nhanh vị trí.' },
      { icon: IconZoneGray, title: 'Xem bản đồ trong nhà', desc: 'Hiển thị vị trí xe trên bản đồ.' },
      { icon: IconDashboard, title: 'Bảng trạng thái trực tiếp', desc: 'Xem tất cả xe & tình trạng.' },
      { icon: IconRoute, title: 'Hiển thị lộ trình', desc: 'Dự đoán tránh xung đột.' },
      { icon: IconClockGray, title: 'Lưu giờ ra vào', desc: 'Tự động lưu lịch sử ra vào.' },
      { icon: IconChartRadius, title: 'Báo cáo tồn kho', desc: 'Tạo báo cáo tự động từ dữ liệu.' },
      { icon: IconUserCheck, title: 'Nâng hiệu suất', desc: 'Xác định nhanh, làm việc hiệu quả.' },
    ],
  },

  system: {
    title: 'Cấu hình hệ thống',
    img: rtlsSystem,
  },

  productTitle: 'Cấu hình sản phẩm',
  product: [{ tag: 'workerPackage' }, { tag: 'assetPackage' }],

  contents: [{ data: 'constructionAsset' }, { data: 'constructionEquipment' }, { data: 'blogRTLS' }, { data: 'blogMedical' }],
};
